export default function Divider() {
  return {}
}
